// extracted by mini-css-extract-plugin
export default {"page":"styles_page__TNzhv","title":"styles_title__0cLVX","submitButton":"styles_submitButton__D5Ib1","divider":"styles_divider__Exdqk","accordion":"styles_accordion__yn9yH"};